import { noop } from 'lodash';
import { resolveNewAppUrl } from './resolve-new-app-url';
import { newAccountCheckService } from 'services/new-account-check/new-account-check.service';

/** Never settles, so nothing downstream runs once the browser is replacing this document. */
const holdForNavigation = (): Promise<never> => new Promise(noop);

/**
 * New accounts may not use the old application, so bootstrap sends them to the new one before the
 * router mounts. No transition has run at that point, so `registerNewApplication` has not had a
 * chance to map their deep link — the destination must be resolved from the URL they arrived on, or
 * the link is lost.
 *
 * Resolves only when the account stays in the old app. Once it starts navigating it holds forever:
 * the rest of bootstrap would otherwise keep running against a document that is going away, and any
 * navigation it triggers — a 401 logout redirect, say — would replace the deep link just resolved.
 */
export const redirectNewAccountToNewApp = async (): Promise<void> => {
  if (!(await newAccountCheckService.checkNewAccount())) return;

  window.location.replace(resolveNewAppUrl(window.location));

  await holdForNavigation();
};
